<template>
  <div class="press">
    <div class="campus">电商管理
      <span>></span>
      课程管理
    </div>

    <div class="xiaoqu">
      <el-card :span="24">
        <div class="grid-content">
          <div class="header">全部课程</div>
          <p class="prompt">
            <i class="el-icon-warning"></i>小程序里所有类型的课程都在此处新建，您可设置新建的课程是免费还是付费，以及课程标签及更多课程的有关设置
          </p>
          <el-form ref="forms" :model="forms" :rules="FormRules" label-width="300px">
            <el-form-item label="课程名称:" prop="name">
              <el-input v-model="forms.name" placeholder="请输入课程名称" rows="9" style="width:560px; marginRight:20px;"></el-input>
            </el-form-item>
            <el-form-item label="课程封面:" prop="picurl">
              <div class="course_cover">
                <img :src="forms.picurl" class="avatar mt-10" />
              </div>
              <el-upload class="avatar-uploader" action="#" :auto-upload="false" v-model="forms.picurl" :show-file-list="false"
                :on-change="collectlist">
                <el-button type="primary" size="small">更换封面</el-button>
              </el-upload>
              <div class="jianyi">
                <span>（ 此图片为课程的封面展示图像，其展示在课程的活动营销列表处）</span>
              </div>
            </el-form-item>
            <el-form-item label="课程类型:" prop="type">
              <el-select v-model="forms.type" @change="onSelectedDrug($event)">
                <el-option v-for="(item) in typeList" :key="item.id" :label="item.value" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="课程价格:" prop="price">
              <el-input v-model="forms.price" placeholder="请输入价格" rows="9" style="width:560px;"
                @onkeyup="this.value=this.value.replace(/[^0-9,.]/g,'')"></el-input>
            </el-form-item>
            <el-form-item label="内容视频链接:" prop="contentLink">
              <el-input v-model="forms.contentLink" placeholder="请输入视频链接" rows="9" style="width:560px;"></el-input>
            </el-form-item>
            <el-form-item label="课程标签:" prop="discount">
              <el-checkbox-group v-model="forms.label" @change="uploadLabel">
                <el-checkbox v-for="(item) in labelList" :key="item.id" :label="item.id" :value="item.id">
                  <span :style="{'color':item.fontColor,'background':item.backgroundColor,}">{{item.name}}</span>
                </el-checkbox>
              </el-checkbox-group>
            </el-form-item>
            <el-form-item label="推荐指数:" prop="classhot">
              <el-input-number v-model="forms.hot" :min="0" :max="10000" @onkeyup="this.value=this.value.replace(/[^0-9]/g,'')">
              </el-input-number>
            </el-form-item>
            <el-form-item label="课程数量:" prop="number">
              <el-input-number v-model="forms.number" :min="0" :max="99999999" @onkeyup="this.value=this.value.replace(/[^0-9]/g,'')">
              </el-input-number>
            </el-form-item>
            <el-form-item label="介绍视频:" prop="videoUrl">
              <div class="intruduce_video"><video class="avatar mt-10" :src="forms.videoUrl" autoplay></video> <span>{{videoName}}</span>
              </div>
              <el-upload class="avatar-uploader" action="#" :auto-upload="false" v-model="forms.videoUrl" :show-file-list="false"
                :on-change="uploadvadio">
                <el-button v-if="!forms.videoUrl" type="primary" size="samll">添加视频</el-button>
              </el-upload>
              <el-button class="avatar-uploader" style="marginTop:10px;" v-if="forms.videoUrl" type="primary"
                @click="forms.videoUrl='';videoName=''" size="samll">删除视频</el-button>
            </el-form-item>
            <el-form-item label="课程信息:" prop="shortname">
              <el-input type="textarea" v-model="forms.shortname" style="width:560px;" placeholder="请输入课程简介" resize="none"></el-input>
            </el-form-item>
            <el-form-item label="课程详情:">
              <div class="detailsPhotos">
                <el-upload action="#" ref="photo" accept="image/png,image/jpg,image/jpeg" multiple :limit="10" :auto-upload="false"
                  list-type="picture-card" :on-remove="handleRemoveImage" :on-change="changeImage" :on-success="uploadSuccess"
                  :http-request="handleChangeImage" :file-list="forms.details">
                  <i class="el-icon-plus"></i>
                </el-upload>
              </div>
            </el-form-item>
            <el-form-item label="课程目录:" prop="coursedetails">
              <el-button type="primary" style="marginLeft:20px;" @click="newcatalogue">新建目录</el-button>
            </el-form-item>
            <div class="tableStyle">
              <el-table :data="tableData" style="width: 70%;marginLeft:300px;">
                <el-table-column prop="seqNum" label="目录序号" align="center">
                </el-table-column>
                <el-table-column prop="name" label="目录名称" align="center">
                </el-table-column>
                <el-table-column label="操作" align="center">
                  <template slot-scope="scope">
                    <el-button type="text" @click="editcatalogue(scope.row)">编辑</el-button>
                    <el-button type="text" @click="delectecatalogue(scope.row)">删除</el-button>
                    <el-button type="text" @click="editcatalogue(scope.row)">查看</el-button>
                  </template>
                </el-table-column>
              </el-table>
            </div>

          </el-form>
        </div>
        <el-button v-if="this.$route.query.id" type="primary" style="width:200px;margin:50px 200px 50px 400px;" @click="editcourse()" round>
          保存编辑</el-button>
        <el-button v-else type="primary" style="width:200px;margin:50px 200px 50px 400px;" @click="addcourse()" round>保存</el-button>
        <el-button style="width:200px;" @click="comeback" round>返回</el-button>

      </el-card>
    </div>
    <div class="dialogStyle">
      <!-- 新建,编辑目录 -->
      <el-dialog :title="dialogType ? '编辑目录':'新增目录'" :visible.sync="publicDialog" width="600px" center>
        <el-form ref="forms" :model="forms" label-width="120px">
          <el-form-item label="目录名称:">
            <el-input v-model="forms.cataloguename" placeholder="请输入课程名称"></el-input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="publicDialog = false">取 消</el-button>
          <el-button type="primary" @click="submitAdd()">确 定</el-button>
        </span>
      </el-dialog>
    </div>

  </div>
</template>

<script>
const FormRules = {
  name: [
    {
      required: true,
      message: '请输入课程名称',
      trigger: ['blur', 'change'],
    },
  ],
  price: [
    {
      required: true,
      message: '请输入价格',
      trigger: ['blur', 'change'],
    },
  ],
  contentLink: [
    {
      required: true,
      message: '请输入视频链接',
      trigger: ['blur', 'change'],
    },
  ],
  number: [
    {
      required: true,
      message: '请选择或输入数量',
      trigger: ['blur', 'change'],
    },
  ],
  type: [
    {
      required: true,
      message: '请选择类型',
      trigger: ['blur', 'change'],
    },
  ],
};
export default {
  data() {
    return {
      FormRules,
      searchName: '',
      tableData: [],
      // 检索表单数据对象
      page: 1,
      pageSize: 10,
      total: 0,
      videoName: '',
      classtypes: '',
      chooseClass: [],
      labelList: [],
      fileList: [],
      typeList: [
        {
          value: '综合课程',
          id: 1,
        },
        {
          value: '专项课程',
          id: 2,
        },
      ],
      publicDialog: false,
      sceondkillId: '',
      dialogType: '',
      courseId: '',
      typeLabelValue: '',
      forms: {
        type: 1,
        name: '',
        number: '',
        label: [],
        shortname: '',
        cataloguename: '',
        catalogueseqNum: '',
        price: '',
        contentLink: '',
        catalogueId: '',
        details: [],
        catalogue: '',
        picurl: '',
        videoUrl: '',
        hot: '',
        discount: '',
      },
    };
  },
  created() {
    this.queryLabel();
    if (Boolean(this.$route.query.id) == true) {
      this.lookcourse();
    }
  },
  methods: {
    uploadLabel() {
      console.log(this.forms.label);
    },
    //新建目录
    newcatalogue() {
      if (Boolean(this.$route.query.id) == true) {
        this.dialogType = '';
      } else {
        this.dialogType = 0;
      }

      this.publicDialog = true;
    },
    //删除目录
    delectecatalogue(row) {
      if (Boolean(this.$route.query.id) == true) {
        let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '');
        let pro = this.$http({
          url: '/edu/mall/course/catalogue/' + row.id + '/del',
          method: 'POST',
          headers: {
            Authorization: 'Bearer ' + token,
          },
        });
        pro
          .then((result) => {
            if (result.data.code === 0) {
              this.$message.success('删除成功！');
              this.lookcourse();
            }
          })
          .catch((err) => {
            this.$message.error('删除失败：' + err);
          });
      } else {
        this.tableData.splice(this.tableData.indexOf(row), 1);
        for (let i = 0; i < this.tableData.length; i++) {
          this.tableData[i].seqNum = i + 1;
        }
      }
    },
    comeback() {
      this.$router.go(-1);
    },
    //添加到列表
    submitAdd() {
      if (this.forms.cataloguename == '') {
        return this.$message.error('目录名称不能为空！');
      }
      if (this.dialogType === 0) {
        this.forms.catalogueseqNum = this.tableData.length + 1;
        this.tableData.push({ name: this.forms.cataloguename, seqNum: this.forms.catalogueseqNum, videoUrl: this.forms.cataloguevideo });
        this.forms.cataloguename = '';
      } else if (this.dialogType === 1) {
        let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '');
        let pro = this.$http({
          url: '/edu/mall/course/catalogue/' + this.catalogueId + '/upd',
          method: 'POST',
          data: {
            name: this.forms.cataloguename,
            seqNum: this.forms.catalogueseqNum,
          },
          headers: {
            Authorization: 'Bearer ' + token,
          },
        });
        pro
          .then((result) => {
            if (result.data.code === 0) {
              this.$message.success('编辑成功！');
              this.lookcourse();
              this.publicDialog = false;
              this.forms.cataloguename = '';
              this.forms.catalogueseqNum = '';
            }
          })
          .catch((err) => {
            this.$message.error('编辑失败：' + err);
          });
      } else {
        let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '');
        let pro = this.$http({
          url: '/edu/mall/course/catalogue/' + this.$route.query.id,
          method: 'POST',
          data: {
            name: this.forms.cataloguename,
            seqNum: this.forms.catalogueseqNum,
          },
          headers: {
            Authorization: 'Bearer ' + token,
          },
        });
        pro
          .then((result) => {
            if (result.data.code === 0) {
              this.$message.success('添加成功！');
              this.lookcourse();
              this.publicDialog = false;
              this.forms.cataloguename = '';
              this.forms.catalogueseqNum = '';
            }
          })
          .catch((err) => {
            this.$message.error('添加失败：' + err);
          });
      }
      this.dialogType = '';
      this.publicDialog = false;
    },
    //添加课程
    addcourse() {
      this.$refs['forms'].validate(async (valid) => {
        //   // 如果表单验证失败，停止请求提交
        if (!valid) {
          this.$message.error('信息填写缺失！');
          return;
        } else {
          this.submitAddCousrse();
        }
      });
    },
    submitAddCousrse() {
      let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '');
      let pro = this.$http({
        url: '/edu/mall/course',
        method: 'POST',
        data: {
          name: this.forms.name,
          price: Number(this.forms.price),
          contentLink: this.forms.contentLink,
          stock: this.forms.number,
          type: this.forms.type,
          coverUrl: this.forms.picurl,
          detail: this.forms.details,
          hot: this.forms.hot,
          desc: this.forms.shortname,
          videoUrl: this.forms.videoUrl,
          labelIds: this.forms.label,
        },
        headers: {
          Authorization: 'Bearer ' + token,
        },
      });
      pro
        .then((result) => {
          this.FormRules;
          if (result.data.code === 0) {
            this.courseId = result.data.data.courseId;
            this.getcourselist();
            this.$message.success('添加成功！');
            this.$router.go(-1);
          }
        })
        .catch((err) => {
          this.$message.error('添加失败：' + err);
        });
    },
    //编辑课程
    editcourse() {
      this.$refs['forms'].validate(async (valid) => {
        //   // 如果表单验证失败，停止请求提交
        if (!valid) {
          this.$message.error('信息填写缺失！');
          return;
        } else {
          if (this.forms.details) {
            this.forms.details.forEach((v, i) => {
              if (v.url) {
                this.forms.details[i] = v.url;
                console.log(this.forms.details, 1111111111);
              }
            });
          }
          this.submitEditcourse();
        }
      });
    },
    submitEditcourse() {
      let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '');
      let pro = this.$http({
        url: '/edu/mall/course/' + this.$route.query.id + '/upd',
        method: 'POST',
        data: {
          name: this.forms.name,
          price: Number(this.forms.price),
          contentLink: this.forms.contentLink,
          stock: this.forms.number,
          type: this.forms.type,
          coverUrl: this.forms.picurl,
          detail: this.forms.details,
          hot: this.forms.hot,
          desc: this.forms.shortname,
          videoUrl: this.forms.videoUrl,
          labelIds: this.forms.label,
        },
        headers: {
          Authorization: 'Bearer ' + token,
        },
      });
      pro
        .then((result) => {
          if (result.data.code === 0) {
            this.$message.success('编辑成功！');
            this.$router.go(-1);
          }
        })
        .catch((err) => {
          this.$message.error('编辑失败：' + err);
        });
    },
    //查看目录
    editcatalogue(row) {
      this.dialogType = 1;
      this.catalogueId = row.id;
      this.publicDialog = true;
      this.forms.cataloguename = row.name;
      this.forms.catalogueseqNum = row.seqNum;
    },
    //查看课程
    lookcourse() {
      let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '');
      let pro = this.$http({
        url: '/edu/mall/course/' + this.$route.query.id,
        headers: {
          Authorization: 'Bearer ' + token,
        },
      });
      pro
        .then((result) => {
          if (result.data.code === 0) {
            let data = result.data.data;
            this.forms.name = data.name;
            this.forms.contentLink = data.contentLink;
            this.forms.picurl = data.coverUrl;
            this.typeLabelValue = data.type;
            this.forms.price = data.price;
            this.forms.hot = data.hot;
            this.forms.type = data.type;
            this.forms.videoUrl = data.videoUrl;
            this.forms.details = data.detailList;
            this.forms.shortname = data.desc;
            this.forms.number = data.stock;
            this.tableData = data.dirs;
            for (let i = 0; i < data.labels.length; i++) {
              this.forms.label.push(data.labels[i].id);
            }
            this.fileList = [];
            data.detailList.forEach((v) => {
              this.fileList.push({ url: v });
              this.forms.details = this.fileList;
            });
          }
        })
        .catch((err) => {
          this.$message.error('查询失败：' + err);
        });
    },
    //新建目录
    getcourselist() {
      let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '');
      let pro = this.$http({
        url: '/edu/mall/course/catalogue/' + this.courseId + '/batch',
        method: 'POST',
        data: this.tableData,
        headers: {
          Authorization: 'Bearer ' + token,
        },
      });
      pro
        .then((result) => {
          if (result.data.code === 0) {
            this.$message.success('添加成功！');
            this.publicDialog = false;
          }
        })
        .catch((err) => {
          this.$message.error('添加失败：' + err);
        });
    },
    beforeUpload() {
      console.log('即将上传图片');
      this.$refs.photo.submit();
    },
    // 详情页图片删除
    handleRemoveImage(file, fileList) {
      this.forms.details = fileList;
      console.log(fileList);
    },
    // 详情页图片上传
    handleChangeImage(params) {
      console.log(23434234);
      let formData = new FormData();
      formData.append('file', params.file);
      let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '');
      let pro = this.$http({
        url: '/edu/uploadOss/uploadImage',
        method: 'POST',
        data: formData,
        headers: {
          Authorization: 'Bearer ' + token,
        },
      });
      pro
        .then((result) => {
          if (result.data.code === 0) {
            // this.forms.details[this.forms.details.length - 1] = { url: result.data.data, name: 'success' };
          }
        })
        .catch((err) => {
          this.$message.error('上传图片错误：' + err);
        });
    },
    changeImage(file, fileList) {
      console.log(fileList);
      this.forms.details = fileList;
      let formData = new FormData();
      formData.append('file', params.file);
      let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '');
      let pro = this.$http({
        url: '/edu/uploadOss/uploadImage',
        method: 'POST',
        data: formData,
        headers: {
          Authorization: 'Bearer ' + token,
        },
      });
      pro
        .then((result) => {
          if (result.data.code === 0) {
            // this.forms.details[this.forms.details.length - 1] = { url: result.data.data, name: 'success' };
          }
        })
        .catch((err) => {
          this.$message.error('上传图片错误：' + err);
        });
    },
    uploadSuccess() {},
    //上传图片
    collectlist(data) {
      let formData = new FormData();
      formData.append('file', data.raw);
      let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '');
      let pro = this.$http({
        url: '/edu/uploadOss/uploadImage',
        method: 'POST',
        data: formData,
        headers: {
          Authorization: 'Bearer ' + token,
        },
      });
      pro
        .then((result) => {
          if (result.data.code === 0) {
            this.$set(this.forms, 'picurl', result.data.data);
          }
        })
        .catch((err) => {
          this.$message.error('上传图片错误：' + err);
        });
    },
    //上传视频
    uploadvadio(data) {
      this.videoName = data.name;
      let formData = new FormData();
      formData.append('video', data.raw);
      let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '');
      let pro = this.$http({
        url: '/edu/uploadOss/uploadVideo',
        method: 'POST',
        data: formData,
        headers: {
          Authorization: 'Bearer ' + token,
        },
      });
      pro
        .then((result) => {
          if (result.data.code === 0) {
            this.$set(this.forms, 'videoUrl', result.data.data);
          }
        })
        .catch((err) => {
          this.$message.error('上传视频错误：' + err);
        });
    },
    //查询标签
    queryLabel() {
      let token = window.sessionStorage.getItem('userinfo').replace(/"/g, '');
      let pro = this.$http({
        url: '/edu/mall/course/label/type/' + this.forms.type,
        headers: {
          Authorization: 'Bearer ' + token,
        },
      });
      pro
        .then((result) => {
          if (result.data.code === 0) {
            this.labelList = result.data.data;
            console.log(this.labelList);
          }
        })
        .catch((err) => {
          this.$message.error('查询失败：' + err);
        });
    },
    //选择
    handleSelectionChange: function (val) {
      var id = [];
      for (let i = 0; i < val.length; i++) {
        id.push(val[i].id);
      }
      this.chooseClass = id;
    },
    onSelectedDrug(e) {
      this.typeLabelValue = e;
      this.forms.label = [];
      console.log(this.labelList);
      this.queryLabel();
    },
  },
};
</script>

<style lang="less" scoped>
.press {
  .prompt {
    width: 100%;
    height: 2rem;
    background-color: rgba(246, 98, 0, 0.1);
    color: rgba(246, 98, 0, 0.8);
    line-height: 2rem;
    padding-left: 20px;
  }
  .el-input__inner {
    width: 100% !important;
  }
  .intruduce_video {
    width: 560px;
    height: 160px;
    border: 1px solid #cccccc;
    video {
      width: 300px;
      height: 120px;
    }
  }
  .course_cover {
    width: 100px;
    height: 100%;
    border: 1px solid;
    img {
      width: 100%;
    }
  }
  .jianyi {
    font-size: 12px !important;
    color: #cccccc;
    position: absolute;
    top: 0;
    left: 200px;
  }
  .el-button--text:active {
    color: #00a6e6;
  }
  .el-button--text {
    color: #00a6e6;
  }
  .avatar {
    width: 200px;
  }
  .el-dialog__body {
    height: 500px;
  }
  .avatar-uploader {
    position: absolute;
    top: -10px;
    right: 640px;

    img {
      width: 100px;
      height: 100px;
    }
  }
  .class_type {
    display: inline-block;
    margin-left: 400px;
  }
  /deep/.el-upload {
    text-align: left;
  }
  .tableImg {
    width: 80px;
    height: 80px;
  }
  /deep/.el-card__body {
    padding: 0 1.3vw;
  }
  .course_label {
    display: inline-block;
    margin-left: 10px;
    padding: 0 10px;
  }
  .detailsPhotos {
    /deep/.el-upload {
      text-align: center;
    }
  }
}
</style>
